"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNullable = void 0;
const omit_1 = require("../utils/omit");
const parseSchema_1 = require("./parseSchema");
/**
 * For compatibility with open api 3.0 nullable
 */
const parseNullable = (schema, refs) => {
  return `${(0, parseSchema_1.parseSchema)(
    (0, omit_1.omit)(schema, "nullable"),
    refs
  )}.nullable()`;
};
exports.parseNullable = parseNullable;
